
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 343 343"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#92B8B8","d":"M.027 171.311A171.255 171.255 0 0 1 171.283.056v14.392A156.86 156.86 0 0 0 14.42 171.311z"}}),_c('path',{attrs:{"fill":"#F1FCFC","d":"M21.207 211.829a154.715 154.715 0 0 0 236.278 90.876L171.283 174.23z"}}),_c('path',{attrs:{"stroke":"#09A098","stroke-dasharray":"15 20","stroke-width":"1.5","d":"M45.55 223.394a136.263 136.263 0 0 1 99.371-183.632 136.26 136.26 0 0 1 149.22 72.565 136.3 136.3 0 0 1 14.331 57.229"}}),_c('path',{attrs:{"fill":"#73D6D3","d":"M312.044 133.672a145.76 145.76 0 0 1-103.066 178.516 145.76 145.76 0 0 1-75.45 0l8.313-31.025a113.637 113.637 0 0 0 139.178-139.178z"}}),_c('path',{attrs:{"fill":"#fff","d":"M171.77 287.104c63.681 0 115.305-51.842 115.305-115.793 0-63.95-51.624-115.792-115.305-115.792S56.464 107.361 56.464 171.311s51.624 115.793 115.306 115.793"}})])
          )
        }
      }
    